// src/components/shared/constants/systemRequirements.js
import {
  BsCpu,
  BsMemory,
  BsGlobe,
  BsWindows,
  BsApple,
  BsGpuCard,
  BsDisplayFill,
} from 'react-icons/bs';
import {
  FaLinux,
  FaHdd,
  FaNetworkWired,
  FaServer,
  FaKeyboard,
  FaMicrochip,
} from 'react-icons/fa';

export const requirements = [
  {
    name: 'Windows',
    icon: BsWindows,
    color: '#00A4EF',
    specs: [
      {
        icon: BsCpu,
        color: '#FF6B6B',
        label: 'Processor',
        value: [
          <span key="1" className="text-primary fw-bold">
            Intel Core i5
          </span>,
          ' or ',
          <span key="2" className="text-primary fw-bold">
            AMD Ryzen 5
          </span>,
          ' (or better)',
        ],
      },
      {
        icon: BsMemory,
        color: '#4ECDC4',
        label: 'Memory',
        value: [
          <span key="1" className="text-primary fw-bold">
            16 GB
          </span>,
          ' RAM recommended (',
          <span key="2" className="text-secondary">
            8 GB minimum
          </span>,
          ')',
        ],
      },
      {
        icon: FaHdd,
        color: '#45B7D1',
        label: 'Storage',
        value: [
          <span key="1" className="text-primary fw-bold">
            2 GB
          </span>,
          ' available space on ',
          <span key="2" className="text-secondary">
            SSD recommended
          </span>,
        ],
      },
      {
        icon: BsGpuCard,
        color: '#96CEB4',
        label: 'Graphics',
        value: [
          <span key="1" className="text-primary">
            DirectX 11
          </span>,
          ' compatible GPU',
        ],
      },
      {
        icon: BsDisplayFill,
        color: '#D4A5A5',
        label: 'Display',
        value: [
          <span key="1" className="text-primary">
            1920x1080
          </span>,
          ' resolution minimum',
        ],
      },
      {
        icon: FaNetworkWired,
        color: '#FFD93D',
        label: 'Internet',
        value: [
          <span key="1" className="text-primary">
            Broadband
          </span>,
          ' connection required',
        ],
      },
    ],
  },
  {
    name: 'macOS',
    icon: BsApple,
    color: '#999999',
    specs: [
      {
        icon: FaMicrochip,
        color: '#FF6B6B',
        label: 'Processor',
        value: [
          <span key="1" className="text-primary fw-bold">
            Apple Silicon
          </span>,
          ' or ',
          <span key="2" className="text-primary fw-bold">
            Intel Core i5
          </span>,
          '+',
        ],
      },
      {
        icon: BsMemory,
        color: '#4ECDC4',
        label: 'Memory',
        value: [
          <span key="1" className="text-primary fw-bold">
            16 GB
          </span>,
          ' RAM recommended (',
          <span key="2" className="text-secondary">
            8 GB minimum
          </span>,
          ')',
        ],
      },
      {
        icon: FaHdd,
        color: '#45B7D1',
        label: 'Storage',
        value: [
          <span key="1" className="text-primary fw-bold">
            2 GB
          </span>,
          ' available space',
        ],
      },
      {
        icon: FaServer,
        color: '#96CEB4',
        label: 'System',
        value: [
          <span key="1" className="text-primary">
            macOS 11
          </span>,
          ' or later',
        ],
      },
      {
        icon: BsDisplayFill,
        color: '#D4A5A5',
        label: 'Display',
        value: [
          <span key="1" className="text-primary">
            Retina
          </span>,
          ' display supported',
        ],
      },
      {
        icon: FaNetworkWired,
        color: '#FFD93D',
        label: 'Internet',
        value: [
          <span key="1" className="text-primary">
            Broadband
          </span>,
          ' connection required',
        ],
      },
    ],
  },
  {
    name: 'Linux',
    icon: FaLinux,
    color: '#FFA600',
    specs: [
      {
        icon: BsCpu,
        color: '#FF6B6B',
        label: 'Processor',
        value: [
          <span key="1" className="text-primary fw-bold">
            64-bit
          </span>,
          ' processor, ',
          <span key="2" className="text-primary fw-bold">
            2.0 GHz
          </span>,
          '+',
        ],
      },
      {
        icon: BsMemory,
        color: '#4ECDC4',
        label: 'Memory',
        value: [
          <span key="1" className="text-primary fw-bold">
            16 GB
          </span>,
          ' RAM recommended (',
          <span key="2" className="text-secondary">
            8 GB minimum
          </span>,
          ')',
        ],
      },
      {
        icon: FaHdd,
        color: '#45B7D1',
        label: 'Storage',
        value: [
          <span key="1" className="text-primary fw-bold">
            2 GB
          </span>,
          ' available space',
        ],
      },
      {
        icon: FaKeyboard,
        color: '#96CEB4',
        label: 'Distribution',
        value: [
          <span key="1" className="text-primary">
            Ubuntu 20.04
          </span>,
          ' or equivalent',
        ],
      },
      {
        icon: BsDisplayFill,
        color: '#D4A5A5',
        label: 'Display',
        value: [
          <span key="1" className="text-primary">
            1920x1080
          </span>,
          ' resolution minimum',
        ],
      },
      {
        icon: FaNetworkWired,
        color: '#FFD93D',
        label: 'Internet',
        value: [
          <span key="1" className="text-primary">
            Broadband
          </span>,
          ' connection required',
        ],
      },
    ],
  },
];
